import React from 'react';
export function Sponsors() {
  const sponsors = [{
    name: 'Highbeam',
    logo: 'https://cdn.magicpatterns.com/uploads/sthKenr6a9AtqBy8rYDeti/White_H_logotype.png',
    className: 'h-16 md:h-20'
  }, {
    name: 'A2X',
    logo: 'https://cdn.magicpatterns.com/uploads/2yv5YUs8KfZuxFy1crQK34/A2X-White.png',
    className: 'h-12 md:h-14'
  }];
  return <section id="sponsors" className="py-20 bg-[#2F1B10] relative overflow-hidden border-t border-[#8B4513]" data-id="element-224">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'url("https://www.transparenttextures.com/patterns/wood-pattern.png")'
    }} data-id="element-225"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-226">
        <div className="text-center mb-12" data-id="element-227">
          <p className="text-sm uppercase tracking-[0.2em] text-[#D2691E] font-bold mb-3" data-id="element-228">
            In Partnership With
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#FFF8DC] font-serif" style={{
          fontFamily: 'Rockwell, "Courier New", serif'
        }} data-id="element-229">
            Proudly Supported By
          </h2>
          <div className="mt-4 w-20 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-230"></div>
        </div>

        <div className="flex flex-col items-center justify-center gap-10 max-w-4xl mx-auto" data-id="element-231">
          {sponsors.map(sponsor => <img key={sponsor.name} src={sponsor.logo} alt={`${sponsor.name} logo`} className={`${sponsor.className} w-auto object-contain opacity-90 hover:opacity-100 transition-opacity`} data-id="element-232" />)}
        </div>
      </div>
    </section>;
}